import React from "react";

import { VideoPreviewContext } from "../context/VideoPreviewContext";

export const useVideoPreviewContext = () => {
    return React.useContext(VideoPreviewContext);
};
